import { getActiveTab } from './helperFunctions'
import { reProject, reprojectD3 } from './functions'
import { g, updateSVG } from './map/d3Renderer'
import { enableEditButtons } from './map/drawing'
import { getEpsg, getEpsgCode, map } from './map/tools'
import { vectorLayer } from './map/layers'
import { loadingGeometry, materializeToast, simpleToast } from './notifications'
import {
  collection, CURRENT_GEOTYPE, currentLayerId, currentDataProj,
  debug, i18n, locallyAr5,
  setCurrentDataExtent, setCurrentDataProj, setD3Collection, setHighlighted
} from './storage'
import { invisibleStyle } from './styles'

import GeoJSON from 'ol/format/GeoJSON'
import TopoJSON from 'ol/format/TopoJSON'
import { fromExtent } from 'ol/geom/Polygon'
import { get as projGet } from 'ol/proj'

import * as topojson from 'topojson-client'

const geotypes = { point: 'Point', line: 'LineString', surface: 'Polygon' };
export const filterGeometries = (json, type) => {
  const gg = json?.objects?.collection?.geometries || [];
  const olType = geotypes[type];
  const types = [olType, `Multi${olType}`];
  const filtered = gg.filter(g => types.indexOf(g.type) > -1);
  if (gg.length) json.objects.collection.geometries = filtered;
  return filtered;
};

export let rest = `/${import.meta.env.VITE_WS}`;

export let editableRegion = true; // updates in notifyAccordingToResponseStatus

const getBboxAsGeojson = () => {
  const extent = map.getView().calculateExtent(map.getSize());
  // workaround, to avoid data disappearing near top boundary:
  extent[3] += (extent[3] - extent[1]) * 0.2;
  const geojson = new GeoJSON();
  const bbox = geojson.writeGeometryObject(new fromExtent(extent));
  // Add projection:
  bbox['crs'] = { type: 'name', properties: { name: getEpsg() } };
  return bbox;
};

export const prepareRequest = () => {
  const pRequest = {
    layer_id: currentLayerId,
    response_srid: getEpsgCode(),
    envelope: getBboxAsGeojson()
  };

  // needed in almostSameExtent check
  setCurrentDataExtent(map.getView().calculateExtent(map.getSize()));

  return pRequest;
};

export const notifyOutsideResolution = () => {
  loadingGeometry(false);
  // Remove old SVG object
  g.selectAll('path').remove();
  g.selectAll('text').remove();

  // Avoid almostSameExtent when coming back inside valid resolution:
  setCurrentDataExtent([]);
  // Hide selected feature properties:
  $("#info-box-popup").hide();
  setHighlighted(0);

  $('#zoom-in-info-box-popup').show();
  $('#zoom-in-info-text').text(i18n['generic']['zoom-in-info-text']);
  $('#info-box-choose-edit-type').show(); // give possibility to add gps
};

export const notifyAccordingToResponseStatus = (status) => {
  if (debug < 16) console.log('notifyAccordingToResponseStatus,', status);
  const objektet = i18n[CURRENT_GEOTYPE].objektet;
  let msg = null;
  switch (status) {
    case 0: // generic error
      msg = locallyAr5 ?
        'Det blei en feil i området. Prøv på nytt og/eller sjekk \
        om du har rettigheter for å endre dette ' + objektet + '!' :
        'Det oppsto en uventet feil. Gi beskjed til \
        <a href="mailto:reindriftskart@nibio.no">reindriftskart@nibio.no</a>';
      break;
    case 1: // success
      editableRegion = true;
      $('#zoom-in-info-box-popup').hide();
      if (getActiveTab() === 2) $('#info-box-choose-edit-type').show();
      break;
    case 2: // zoom in to edit
      $('#zoom-in-info-box-popup').show();
      $('#zoom-in-info-text').text(i18n['generic']['zoom-in-info-text']);
      $('#info-box-choose-edit-type').hide();
      break;
    case 3: // invalid input line (not used for this request)
      break;
    case 4: // outside user's editable region
      editableRegion = false;
      break;
    case 1100: // no right to update attributes
      const t11 = objektet.replace('arealet', 'nne flaten')
        .replace('linje', 'nne linjen').replace('punktet', 'tte punktet');
      msg = `Du har ikke rettigheter til å endre de${t11}!`;
      break;
    case 1200: // invalid drawing
      const t = objektet.replace('arealet', 'grense');
      msg = `Du har tegnet en ulovlig ${t}. Se veileder.`;
      break;
    default:
      console.log('Ukjent feil', status);
  }
  enableEditButtons(); // de/activate buttons
  if (msg) materializeToast(msg, 'error', 12);
};

export const handleResponseGeometry = (json) => {
  if (!json) {
    setD3Collection({});
    // Remove old SVG object
    g.selectAll('path').remove();
    g.selectAll('text').remove();
    $('#zoom-in-info-text').text('Ingen data innenfor valgt område.');
    $('#zoom-in-info-box-popup').show();
  } else {
    try { // D3 geometry is loaded here
      // Convert TopoJSON to GeoJSON, https://github.com/topojson/topojson
      setD3Collection(topojson.feature(json, json.objects.collection));
      setCurrentDataProj(json.crs.properties.name);
    } catch (e) {
      console.log(e);
      console.log('Invalid JSON:', json);
      simpleToast('Kunne ikke hente geometri i dette området', 'error');
      return false;
    }
  }
};

export const loadGeometryToOpenlayers = (json, layer) => {
  layer.getSource().clear();
  if (!json) return;
  let features = [];
  try {
    // OL geometry is loaded here
    const jFormat = json.type === 'Topology' ? TopoJSON : GeoJSON;
    features = new jFormat({
      dataProjection: projGet('EPSG:4326')
    }).readFeatures(json);
  } catch(e) { console.log(e); }

  // Draw outline on polygons
  layer.getSource().addFeatures(features);

  if (['line', 'point'].indexOf(CURRENT_GEOTYPE) > -1)
    layer.setStyle(invisibleStyle);
};

export const loadGeometryToD3 = () => {
  updateSVG(); // Update D3
  const epsg = getEpsg();
  if (epsg !== currentDataProj) reprojectD3(currentDataProj, epsg);
};
